<template lang="pug">
  
  .LoadingCover(
    :class="{'fullscreen': fullscreen}"
  )
    Loading.blue.x3.loading
    .text {{ text }}
    .text.sub {{ subText }}

</template>

<script>
export default {
  name: "LoadingCover",
  
  props: {
    text: {
      type: String
    },
    subText: {
      type: String
    },
    fullscreen: {
      type: Boolean
    }
  }
}
</script>

<style lang="scss" scoped>

  .LoadingCover {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: rgba(white, 0.8);
    z-index: 1000;

    .text {
      margin-top: 30px;
      color: rgba($color-navy, .8);
      font-size: 22px;

      &.sub {
        margin-top: 15px;
      }
    }

    &.fullscreen {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      z-index: 1000;
    }

    .loading {
      flex: 0 0 auto;
    }

  }

</style>


